import {Fragment, UUID} from '@nh/angular-tses';
import {DepartureIdLookupEntry} from 'app/departures/departure/departure-id-lookup.entry';
import {DASFragmentType} from './das-fragment-type';

export enum ConditionState {
  TO_BE_CONFIRMED = 'TO_BE_CONFIRMED',
  ADHERED_TO = 'ADHERED_TO',
  NOT_ADHERED_TO = 'NOT_ADHERED_TO',
  PARTIALLY_ADHERED_TO = 'PARTIALLY_ADHERED_TO',
  STATUS_WILL_NOT_BE_CONFIRMED = 'STATUS_WILL_NOT_BE_CONFIRMED',
}

/**
 * A class representing a Condition Fragment used for recording conditions against a departure.
 */
export class ConditionFragment extends Fragment {
  public static readonly NO_CONDITION_KEY: string = 'Unknown';

  /**
   * Static helper to return an empty condition fragment.
   *
   * @returns {ConditionFragment}   The condition fragment
   */
  public static empty(conditionState: ConditionState = ConditionState.TO_BE_CONFIRMED): ConditionFragment {
    return new ConditionFragment(null, '', '', conditionState);
  }

  /**
   * Gets the condition key from the given DepartureIdLookupEntry and the index of the parent clause.
   * Note that the index of the parent clause is the position of the condition in the condition list.
   * We don't use the index of the condition itself as it's the only child of its parent clause.
   */
  public static getConditionKey(departureEntry: DepartureIdLookupEntry, index: number): string {
    return `${departureEntry.departureId} - rev ${departureEntry.revision} - ${index + 1}`;
  }

  constructor(
    id: UUID,
    public condition: string = '',
    public comment: string = '',
    public conditionState: ConditionState = null
  ) {
    super(id, DASFragmentType.CONDITION, [], '');
  }

  /**
   * @inheritDoc
   */
  public split(offset: number): ConditionFragment {
    return null;
  }
}

/**
 * Deserialiser function for Condition Fragments.
 *
 * @param json {any}                JSON object to deserialise
 * @returns    {ConditionFragment}   Deserialised Condition Fragment Object
 */
export function deserialiseConditionFragment(json: any): ConditionFragment {
  return new ConditionFragment(
    UUID.orThrow(json.id),
    json.condition,
    json.comment,
    json.conditionState as ConditionState
  );
}
